<template>
    <div>
        <div class="lgn">
            <el-form :model="ruleForm" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="账号" prop="username">
                    <el-input v-model.number="ruleForm.username"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pass">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            // var validateuser = (rule, value, callback) => {
            //     if (!value) {
            //     return callback(new Error('账号不能为空'));
            //     }
            //     setTimeout(() => {
            //     if (!Number.isInteger(value)) {
            //         callback(new Error('请输入数字值'));
            //     } else {
            //         if (value.length < 11) {
            //         callback(new Error('请输入账号'));
            //         } else {
            //         callback();
            //         }
            //     }
            //     });
            // };
            // var validatePass = (rule, value, callback) => {
            //     if (value === '') {
            //         callback(new Error('请输入密码'));
            //     } else {
            //         if (this.ruleForm.checkPass !== '') {
            //             this.$refs.ruleForm.validateField('checkPass');
            //         }
            //         callback();
            //     }
            // };
            return {
                ruleForm: {
                    pass: '',
                    username: ''
                },
                // rules2: {
                //     pass: [
                //         { validator: validatePass, trigger: 'blur' }
                //     ],
                //     username: [
                //         { validator: validateuser, trigger: 'blur' }
                //     ]
                // }
            };
        },
        created() {
            this.$changeTitle('登录--');
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http.post('/api/v2/auth/login',
                            {
                                'device_type':'pc',
                                username: this.ruleForm.username,
                                password: this.ruleForm.pass
                            },
                            {
                                headers:
                                    {
                                        'Device-Type':'pc',
                                    }
                            }
                            ).then((res) => {
                                if(res.data.code===1){
                                    localStorage.setItem('token',res.data.data.token);
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'success',
                                        showClose:true
                                    });
                                }else if(res.data.code===0){
                                    this.$message.error({message:res.data.msg,showClose:true})
                                }
                            //localStorage.setItem('token',res.data.data.token);
                            // this.listData = res.data.data.data
                            // console.log(localStorage.getItem('token'))
                            }).catch((err) => {
                                    // console.log(err);
                            })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>
    .lgn{
        width: 350px;
    }
</style>


// WEBPACK FOOTER //
// src/page/Login.vue